import { ArrowRightOutlined } from "@ant-design/icons";
import { Card } from "antd";
import { useMediaQuery } from "react-responsive";

const WhyUsCard = ({ title, desc, iconimg }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <Card
      // hoverable
      className="why-us-cards"
      style={
        isMobile
          ? {
              position: "relative",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }
          : { position: "relative",cursor:"" }
      }
    >
      <div className="why-us-card-img">
        <img src={iconimg} alt={title} />
      </div>
      <div className="card-title" style={{ marginTop: "28px" }}>
        {title}
      </div>
      <div
        className="card-content-text"
        // style={{ marginBottom: "40px" }}
      >
        {desc}{" "}
      </div>
      {/* <div
      className="header-menu-title"
      style={{ position: "absolute", bottom: "20px" }}
    >
      Read More <ArrowRightOutlined size={"14px"} />
    </div> */}
    </Card>
  );
};
export default WhyUsCard;
